import React, {useState, Component} from 'react';
import * as firebase from 'firebase'
import { Redirect, Route } from 'react-router'
import Header from './Header.js';
import Footer from './Footer.js';

export default class Success extends Component {
  // const [weightText, setWeightText] = useState("")
constructor(props){
   super(props);
   this.state={
    
   }
} 


componentDidMount(){
  localStorage.setItem('finished', 'true')
}
   

render(){
  

let applicationID = localStorage.getItem('applicationID')
 let passedFinal = localStorage.getItem('passedFinal')


  
  if (passedFinal === 'true') {
  return (
    <>
    <Header/>
    <div class="container" style={{marginTop: 120}}>
      <h3 style={{color: 'green', textAlign: 'center', marginBottom: 20}}>Congratulations !</h3>
      <h5 style={{ textAlign: 'center', color: 'gray', marginBottom: 25}}>Your Application has been received. Kindly take note of your Application ID.</h5>

  <h1 style={{ textAlign: 'center', color: 'gray', fontFamily: 'fantasy', marginBottom: 70}}>NYE/{applicationID}/2021</h1>


  
 </div>
      <Footer/>
      </>
    );
      }
    else return (
      <Redirect to={'/'} />
    )
  }
}

//export default ApplicationForm;
